<script setup>
import { computed } from 'vue'
import logoImg from '~/assets/images/logo.jpeg'

const props = defineProps({
  collapsed: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['close', 'toggle-collapse'])
const route = useRoute()
const isSettingsActive = computed(() =>
  route.path.startsWith('/settings') || route.path.startsWith('/integration-settings'),
)
const config = useRuntimeConfig()
const termsUrl = `${config.public.apiBase || '/api/v3/'}general/terms-of-purchase`
</script>

<template>
  <div class="nav-header">
    <NuxtLink class="nav-brand" to="/vouchers" aria-label="BGA">
      <img class="nav-logo nav-logo--full" :src="logoImg" alt="BGA" />
      <img class="nav-logo nav-logo--icon" :src="logoImg" alt="" aria-hidden="true" />
    </NuxtLink>

    <div class="nav-header-actions">
      <AppIconButton
        class="nav-collapse"
        size="sm"
        aria-label="Toggle menu"
        @click="emit('toggle-collapse')"
      >
        <AppIcon
          :name="props.collapsed ? 'hero-chevron-double-right' : 'hero-chevron-double-left'"
          size="lg"
        />
      </AppIconButton>

      <AppIconButton class="nav-close" size="sm" aria-label="Close menu" @click="emit('close')">
        <AppIcon name="hero-x-mark" size="lg" />
      </AppIconButton>
    </div>
  </div>

  <nav class="nav-items" aria-label="Primary">
    <NuxtLink class="nav-link" to="/home" @click="emit('close')">
      <AppIcon class="nav-item-icon" name="hero-home" size="md" />
      <span class="nav-item-title">Hem</span>
    </NuxtLink>

    <NuxtLink class="nav-link" to="/vouchers" @click="emit('close')">
      <AppIcon class="nav-item-icon" name="hero-document-text" size="md" />
      <span class="nav-item-title">Verifikationer</span>
    </NuxtLink>

    <NuxtLink
      class="nav-link"
      :class="{ 'router-link-active': isSettingsActive }"
      to="/settings"
      @click="emit('close')"
    >
      <AppIcon class="nav-item-icon" name="hero-cog-6-tooth" size="md" />
      <span class="nav-item-title">Inställningar</span>
    </NuxtLink>

    <NuxtLink class="nav-link" to="/transaction-logs" @click="emit('close')">
      <AppIcon class="nav-item-icon" name="hero-list-bullet" size="md" />
      <span class="nav-item-title">Händelselogg</span>
    </NuxtLink>
  </nav>

  <div class="sidebar-legal">
    <div class="sidebar-legal__company">
      Connectivo AB · Org nr: 556932-7777
    </div>
    <div class="sidebar-legal__links">
      <a :href="termsUrl" target="_blank" rel="noopener" class="sidebar-legal__link">
        Köpvillkor (PDF)
      </a>
      <NuxtLink to="/cookies" class="sidebar-legal__link" @click="emit('close')">
        Cookies
      </NuxtLink>
    </div>
  </div>
</template>

<style scoped>
.sidebar-legal {
  margin-top: auto;
  padding-top: var(--lp-space-4);
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  gap: var(--lp-space-3);
}

.sidebar-legal__company {
  line-height: 1.4;
}

.sidebar-legal__links {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sidebar-legal__link {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
}

.sidebar-legal__link:hover {
  color: rgba(255, 255, 255, 0.95);
}
</style>
